var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHunterCharacterBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1190,
    height: 813,
    viewBox: "0 0 1190 813",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddi_145_29563)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 23.4194,
    width: 1132,
    height: 756.345,
    rx: 24.3254,
    fill: "url(#paint0_linear_145_29563)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 18.4194,
    width: 1142,
    height: 766.345,
    rx: 29.3254,
    stroke: "url(#paint1_linear_145_29563)",
    strokeWidth: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddi_145_29563",
    x: 0.755932,
    y: 0.0404501,
    width: 1188.49,
    height: 812.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.5139
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.608136
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.447059 0 0 0 0 0.152941 0 0 0 0 0.00392157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_145_29563"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.86508
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.12203
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.0588235 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_145_29563",
    result: "effect2_dropShadow_145_29563"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_145_29563",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7.29763,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect3_innerShadow_145_29563"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 16.33,
    dy: 22.06
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.608136
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.4625 0 0 0 0 0.186127 0 0 0 0 0.00770833 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect3_innerShadow_145_29563"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_145_29563",
    x1: 595,
    y1: 23.4194,
    x2: 612.303,
    y2: 779.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#9B4605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E2401"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_145_29563",
    x1: 858.936,
    y1: 71.8729,
    x2: 332.393,
    y2: 612.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D17B0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52422,
    stopColor: "#FCA22D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728844,
    stopColor: "#CD7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#973E04"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHunterCharacterBg);
export default __webpack_public_path__ + "static/media/hunter-character-bg.5e448bd54e81adde5b4c776f75bb36e7.svg";
export { ForwardRef as ReactComponent };